import { Address } from 'viem'

export const OWNABLE_EXECUTOR_ADDRESS: Address =
  '0x4Fd8d57b94966982B62e9588C27B4171B55E8354'
